<template>
  <div class="import-main">
    <div style="display: flex; width: 100%; height: fit-content">
      <div class="top-section-wrapper">
        <div v-show="showTopSection" class="top-section" style="width: 100%; height: auto">
          <div style="display: flex; gap: 10px">
            <Dropdown
              ref="doctype"
              placeholder="Document Type"
              :isRequired="true"
              :items="documentTypeFilter"
              itemKey="placeholder"
              :selectedObject.sync="selectedDocumentType"
              style="width: 25%"
              :isDisabled="true"
            />
            <Dropdown
              placeholder="Template Type"
              :items="templateTypeList"
              itemKey="label"
              :selectedObject.sync="selectedTemplateType"
              :isDisabled="smkItemList.length > 0"
              style="width: 25%"
            />
            <Tooltip
              v-if="selectedTemplateType && selectedTemplateType.value === 'VEHICLE'"
              position="right"
              :minWidth="300"
              tooltipText="Recommended to use Packing List document with clear table structure and column titles for better accuracy."
            />
            <button
              v-if="lastCIItems.length && lastPLItems.length"
              @click="reselectItemSource"
              style="margin-left: 5px"
            >
              Reselect Source
            </button>
          </div>
          <div style="display: flex; margin-top: 25px" id="file-input">
            <Input
              textType="file"
              placeholder="Select File"
              :inputValue.sync="importDoc['docName']"
              @fileChanged="handleFileUpload"
              style="width: fit-content; margin-right: 5px"
            />
            <span v-if="processorVersion != ''" style="margin-left: auto"
              >Processor Version: {{ processorVersion }}</span
            >
          </div>
          <div v-if="embedSrc && totalPages > 1 && showPageSelector">
            <div class="pdf-guidance">
              <b>Tip:</b> &bull; Select the page range that contains the
              <strong>relevant document information (CI/PL item pages)</strong> then click
              <strong>Process PDF</strong>.<br />
              &bull; Avoid including blank or unrelated pages to improve AI processing accuracy.<br />
              &bull; AI detection works best with clear, high-resolution documents. Blurry or distorted images may
              result in missing or incorrect data.<br />
              &bull; AI can make mistakes. Check and review all important information.
            </div>
            <div class="page-selector">
              <span>Select Pages:</span>

              <Dropdown
                placeholder="Start"
                :items="pageOptions"
                itemKey="Page"
                :selectedObject.sync="pageStartObj"
                style="width: 80px"
              />

              <span>to</span>

              <Dropdown
                placeholder="End"
                :items="pageOptions"
                itemKey="Page"
                :selectedObject.sync="pageEndObj"
                style="width: 80px"
              />

              <button @click="processSelectedPages">Process PDF</button>

              <span class="page-count"> ( {{ selectedPageCount }} selected / {{ totalPages }} pages ) </span>
            </div>
          </div>
        </div>
        <img
          class="collapse-top-section"
          src="https://dsmapi.logistics.systems/dsm6gicons/icons8-expand-arrow-24.png"
          @click="showTopSection = !showTopSection"
          :style="{ transform: `rotate(${showTopSection ? 180 : 0}deg)` }"
        />
      </div>
      <!-- <div class="top-section" style="width: 10%; height: auto; display: flex; flex-direction: column">
        <div>
          Download Template
          <div style="display: flex">
            <a
              href="/ImportTemplates/ImportAPInvoiceExcel.xlsx"
              download="APInvoiceTemplate.xlsx"
              style="align-content: center; margin-left: 10px"
              ><Tooltip
                icon="https://dsmapi.logistics.systems/dsm6gIcons/ExportExcel.png"
                tooltipText="Download Excel Template"
                style="cursor: pointer"
            /></a>
            <a
              href="/ImportTemplates/ImportAPInvoiceCSV.csv"
              download="APInvoiceTemplate.csv"
              style="align-content: center; margin-left: 10px"
              ><Tooltip
                icon="https://dsmapi.logistics.systems/dsm6gIcons/ExportCSV.png"
                tooltipText="Download CSV Template"
                style="cursor: pointer"
            /></a>

            <a
              href="/ImportTemplates/ImportAPInvoiceTxt.txt"
              download="APInvoiceTemplate.txt"
              style="align-content: center; margin-left: 10px"
              ><Tooltip
                icon="https://dsmlib.logistics.systems/Icons/TXTFile.png"
                tooltipText="Download Txt Template"
                style="cursor: pointer"
            /></a>
          </div>
        </div>
        <button @click="customTemplateClicked" style="margin-top: 10px">Custom Templates</button>
      </div> -->
    </div>

    <div class="bottom-section">
      <div class="top-div" id="top-section">
        <div class="table-container top-left-div" id="left-pane" :style="topLeftDivWidth">
          <iframe class="pdf-display" v-if="showPDF && embedSrc" type="video/webm" :src="embedSrc"></iframe>
          <div v-else class="user-instructions">
            <span>
              Click on <strong> Select File </strong> or drag and drop a Commercial Invoice/Packing List PDF document to
              get started
            </span>
          </div>
          <!-- <TableBox
            title="Uploaded Data"
            :tableData="uploadedData"
            v-else-if="showUploadedDataTable"
            :loading="!showUploadedDataTable"
            style="height: calc(100% - 25px); overflow: scroll"
            :rowHeight="35"
            groupBy="InvNo"
          /> -->
        </div>
        <!-- RESIZER -->
        <div class="resizer-x" id="resizer-x" @mousedown="startResize">
          <button class="collapse-btn" @click.stop="togglePDF">
            {{ pdfHidden ? '⟩' : '⟨' }}
          </button>
        </div>
        <div
          class="table-container top-right-div"
          :class="{ 'has-batch-panel': selectedCount > 0 }"
          id="right-pane"
          :style="topRightDivWidth"
        >
          <div class="add-button-container">
            <button @click="addSMKItem" class="add-item-btn">Add Item</button>
            <button @click="openBatchAddPopup" class="add-item-btn" style="margin-left: 5px; width: 30%">
              Batch Add
            </button>
            <button
              @click="deleteSMKItemAll"
              :disabled="smkItemList.length === 0"
              class="deleteall-item-btn"
              style="margin-left: 5px; width: 20%"
            >
              Delete All
            </button>
          </div>
          <div class="batch-panel sticky-top" v-if="selectedCount > 0">
            <span>{{ selectedCount }} selected</span>

            <!-- FIELD SELECTOR -->
            <Dropdown
              placeholder="Select field"
              :items="batchFieldOptions"
              itemKey="label"
              :selectedObject.sync="selectedBatchFieldObj"
              style="width: 180px"
            />

            <!-- DYNAMIC INPUT -->
            <div v-if="batchField">
              <!-- TEXT OR NUMBER -->
              <Input
                v-if="fieldConfig[batchField].type === 'text' || fieldConfig[batchField].type === 'number'"
                :validator="fieldConfig[batchField].type === 'number' ? 'decimal,15,4' : 'text,50'"
                :inputValue.sync="batchValue"
                :placeholder="'Enter ' + fieldConfig[batchField].label"
                style="width: 150px"
              />

              <!-- DROPDOWN using InputQuery -->
              <InputQuery
                v-else-if="fieldConfig[batchField].type === 'dropdown'"
                :items="generalInfoData[fieldConfig[batchField].source]"
                :itemKey="fieldConfig[batchField].itemKey"
                :descKey="fieldConfig[batchField].descKey"
                :selectedObject.sync="batchValue"
                style="width: 180px"
                :placeholder="'Select ' + fieldConfig[batchField].label"
              />
            </div>

            <button @click="applyBatchEdit">Apply</button>
            <button @click="deleteSelected">Delete Selected</button>
            <button @click="clearSelected">Clear</button>
          </div>

          <div class="smk-wrapper">
            <div class="smk-title-row" v-if="smkItemList && smkItemList.length > 0">
              <span class="title">SMK Item</span>

              <Tooltip
                @click.native="exportSMKItemExcel"
                v-if="smkItemList && smkItemList.length > 0"
                icon="https://dsmapi.logistics.systems/dsm6gIcons/ExportExcel.png"
                tooltipText="Export to Excel"
                style="cursor: pointer; margin-left: 5px"
              />
            </div>

            <div class="table-box-main smk-edit-table" v-if="smkItemList && smkItemList.length > 0">
              <!-- toolbar -->
              <div class="top-block">
                <div class="right-section">
                  <input v-model="searchText" class="table-search" placeholder="Search..." />
                </div>

                <div class="left-section">
                  <span>{{ filteredSMKItemList.length }} of {{ smkItemList.length }} records</span>
                </div>
              </div>

              <div class="table-block" ref="scrollBlock">
                <!-- HEADER -->
                <div class="table-header">
                  <div
                    v-for="(col, colIndex) in displayColumns"
                    :key="col.key"
                    class="table-column blue-theme"
                    :class="{
                      'sticky-column': col.key === 'select',
                      'select-col': col.key === 'select',
                      'seq-col': col.key === 'seq',
                      'action-col': col.key === 'action',
                    }"
                    draggable="true"
                    @dragstart="onColumnDragStart(colIndex)"
                    @dragover.prevent
                    @drop="onColumnDrop(colIndex)"
                    @dblclick="autoFit($event, colIndex)"
                    :style="{
                      width: (col.width || 140) + 'px',
                      minWidth: (col.width || 140) + 'px',
                      maxWidth: (col.width || 140) + 'px',
                    }"
                  >
                    <div class="title-block">
                      <template v-if="col.type === 'checkbox'">
                        <input type="checkbox" class="big-checkbox" v-model="selectAll" @change="toggleSelectAll" />
                      </template>

                      <template v-else>
                        <span>{{ col.label }}</span>
                      </template>
                    </div>

                    <!-- simple filter row -->
                    <div v-if="!['select', 'seq', 'action'].includes(col.key)" class="filter-block">
                      <input v-model="columnFilters[col.key]" class="column-filter" placeholder="Search" @click.stop />
                    </div>

                    <span
                      class="col-resizer"
                      @mousedown.stop.prevent="startColResize($event, colIndex)"
                      @dragstart.stop.prevent
                    ></span>
                  </div>
                </div>

                <!-- BODY -->
                <div
                  v-for="(row, index) in filteredSMKItemList"
                  :key="row.id || index"
                  class="table-row blue-theme-row"
                  :class="{ 'blue-theme-row-selected': row.selected }"
                >
                  <div
                    v-for="col in displayColumns"
                    :key="col.key"
                    class="row-data"
                    :class="{
                      'sticky-column': col.key === 'select',
                      'select-col': col.key === 'select',
                      'seq-col': col.key === 'seq',
                      'action-col': col.key === 'action',
                      'input-with-icon': ['HSCode', 'StatisticalUOM', 'DeclaredUOM'].includes(col.key),
                    }"
                    :style="{
                      width: (col.width || 140) + 'px',
                      minWidth: (col.width || 140) + 'px',
                      maxWidth: (col.width || 140) + 'px',
                    }"
                  >
                    <!-- select -->
                    <template v-if="col.key === 'select'">
                      <input
                        type="checkbox"
                        class="big-checkbox"
                        :checked="row.selected"
                        @click="shiftSelect(row, index, $event)"
                      />
                    </template>

                    <!-- seq -->
                    <template v-else-if="col.key === 'seq'">
                      <span>{{ index + 1 }}</span>
                    </template>

                    <!-- Product -->
                    <template v-else-if="col.key === 'Product'">
                      <Input placeholder="" validator="text,25" :inputValue.sync="row['Product']" :isRequired="false" />
                    </template>

                    <!-- CountryOfOrigin -->
                    <template v-else-if="col.key === 'CountryOfOrigin'">
                      <InputQuery
                        placeholder=""
                        :items="generalInfoData['countryList']"
                        itemKey="Country Code"
                        descKey="Country"
                        :selectedObject.sync="row['CountryOfOrigin']"
                        validator="text,2"
                      />
                    </template>

                    <!-- HSCode -->
                    <template v-else-if="col.key === 'HSCode'">
                      <Tooltip
                        v-if="isFreeTextByRow(row, 'HSCode', generalInfoData.tcList, 'Tariff Code')"
                        icon="https://dsmapi.logistics.systems/dsm6gIcons/warning.png"
                        tooltipText="Does not match any value in Tariff Code Master"
                        style="cursor: pointer; margin-right: 5px"
                      />
                      <InputQuery
                        placeholder=""
                        :items="generalInfoData['tcList']"
                        itemKey="Tariff Code"
                        :selectedObject.sync="row['HSCode']"
                        validator="text,25"
                        :allowFreeText="true"
                        @selected="selectedHSCodeByRow(row)"
                      />
                    </template>

                    <!-- StatisticalQty -->
                    <template v-else-if="col.key === 'StatisticalQty'">
                      <Input
                        placeholder=""
                        validator="integer,15"
                        :inputValue.sync="row['StatisticalQty']"
                        :isRequired="false"
                      />
                    </template>

                    <!-- StatisticalUOM -->
                    <template v-else-if="col.key === 'StatisticalUOM'">
                      <Tooltip
                        v-if="isFreeTextByRow(row, 'StatisticalUOM', generalInfoData.uomList, 'UOM Code')"
                        icon="https://dsmapi.logistics.systems/dsm6gIcons/warning.png"
                        tooltipText="Does not match any value in UOM Master"
                        style="cursor: pointer; margin-right: 5px"
                      />
                      <InputQuery
                        placeholder=""
                        :items="generalInfoData['uomList']"
                        itemKey="UOM Code"
                        :selectedObject.sync="row['StatisticalUOM']"
                        validator="text,5"
                        :allowFreeText="true"
                      />
                    </template>

                    <!-- DeclaredQty -->
                    <template v-else-if="col.key === 'DeclaredQty'">
                      <Input
                        placeholder=""
                        validator="integer,15"
                        :inputValue.sync="row['DeclaredQty']"
                        :isRequired="false"
                      />
                    </template>

                    <!-- DeclaredUOM -->
                    <template v-else-if="col.key === 'DeclaredUOM'">
                      <Tooltip
                        v-if="isFreeTextByRow(row, 'DeclaredUOM', generalInfoData.uomList, 'UOM Code')"
                        icon="https://dsmapi.logistics.systems/dsm6gIcons/warning.png"
                        tooltipText="Does not match any value in UOM Master"
                        style="cursor: pointer; margin-right: 5px"
                      />
                      <InputQuery
                        placeholder=""
                        :items="generalInfoData['uomList']"
                        itemKey="UOM Code"
                        :selectedObject.sync="row['DeclaredUOM']"
                        validator="text,5"
                        :allowFreeText="true"
                      />
                    </template>

                    <!-- UnitPrice -->
                    <template v-else-if="col.key === 'UnitPrice'">
                      <Input
                        placeholder=""
                        validator="decimal,15,4"
                        :inputValue.sync="row['UnitPrice']"
                        :isRequired="false"
                      />
                    </template>

                    <!-- ItemAmount -->
                    <template v-else-if="col.key === 'ItemAmount'">
                      <Input
                        placeholder=""
                        validator="decimal,15,4"
                        :inputValue.sync="row['ItemAmount']"
                        :isRequired="false"
                      />
                    </template>

                    <!-- ItemDescription -->
                    <template v-else-if="col.key === 'ItemDescription'">
                      <Input
                        placeholder=""
                        validator="text,25"
                        :inputValue.sync="row['ItemDescription']"
                        :isRequired="false"
                      />
                    </template>

                    <!-- CEPT -->
                    <template v-else-if="col.key === 'CEPT'">
                      <Input placeholder="" validator="text,15" :inputValue.sync="row['CEPT']" :isRequired="false" />
                    </template>

                    <!-- Alcohol -->
                    <template v-else-if="col.key === 'Alcohol'">
                      <InputQuery
                        placeholder=""
                        :items="generalInfoData['alcoholList']"
                        itemKey="Name"
                        :selectedObject.sync="row['Alcohol']"
                        validator="text,3"
                      />
                    </template>

                    <!-- DutyQty -->
                    <template v-else-if="col.key === 'DutyQty'">
                      <Input
                        placeholder=""
                        validator="integer,10"
                        :inputValue.sync="row['DutyQty']"
                        :isRequired="false"
                      />
                    </template>

                    <!-- Vehicle details-->
                    <template v-else-if="col.key === 'Model'">
                      <Input placeholder="" validator="text,50" :inputValue.sync="row['Model']" :isRequired="false" />
                    </template>

                    <template v-else-if="col.key === 'ChassisNo'">
                      <Input
                        placeholder=""
                        validator="text,50"
                        :inputValue.sync="row['ChassisNo']"
                        :isRequired="false"
                      />
                    </template>

                    <template v-else-if="col.key === 'EngineNo'">
                      <Input
                        placeholder=""
                        validator="text,50"
                        :inputValue.sync="row['EngineNo']"
                        :isRequired="false"
                      />
                    </template>

                    <template v-else-if="col.key === 'Brand'">
                      <Input placeholder="" validator="text,50" :inputValue.sync="row['Brand']" :isRequired="false" />
                    </template>

                    <template v-else-if="col.key === 'EngineCapacityQlf'">
                      <Input
                        placeholder=""
                        validator="text,20"
                        :inputValue.sync="row['EngineCapacityQlf']"
                        :isRequired="false"
                      />
                    </template>

                    <template v-else-if="col.key === 'EngineCapacityValue'">
                      <Input
                        placeholder=""
                        validator="text,20"
                        :inputValue.sync="row['EngineCapacityValue']"
                        :isRequired="false"
                      />
                    </template>

                    <template v-else-if="col.key === 'ManufactureDate'">
                      <Tooltip
                        v-if="row['ManufactureDate'] && !isYYYYMMDD(row['ManufactureDate'])"
                        icon="https://dsmapi.logistics.systems/dsm6gIcons/warning.png"
                        tooltipText="Invalid date format. Please use YYYY-MM-DD"
                        style="cursor: pointer; margin-right: 5px"
                      />
                      <Input
                        placeholder=""
                        validator="text,10"
                        :inputValue.sync="row['ManufactureDate']"
                        :isRequired="false"
                      />
                    </template>

                    <!-- action -->
                    <template v-else-if="col.key === 'action'">
                      <button @click="deleteSMKItemByRow(row)">Delete</button>
                    </template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="resizer-y" id="resizer-y"></div>
      <!-- <div class="bottom-div" id="bottom-section">
        <div class="table-container" style="display: flex">
          <TableBox
            title="Imported Successfully"
            v-if="showSuccessInv"
            :tableData="importSuccessInv"
            :additionalButtons="importSuccessInvTableBtn"
            @buttonClicked="importSuccessButtonClicked"
            style="height: 100%; overflow: scroll; width: 50%"
          />
          <div class="message-container" :style="messageBoxStyle" v-html="messageBoxText"></div>
        </div>
      </div> -->
    </div>
    <PopupV2
      :show="showBatchAddPopup"
      title="Batch Add SMK Items"
      :buttons="savePopupButtons"
      @buttonClicked="batchAddPopupButtonClicked"
    >
      <div style="padding: 10px">
        <span>How many SMK items do you want to add?</span>
        <Input
          placeholder="Enter number of items"
          validator="integer,3"
          :inputValue.sync="batchAddCount"
          style="margin-top: 5px; width: 100%"
        />
      </div>
    </PopupV2>
  </div>
</template>
<script>
import Axios from 'axios';
import { PDFDocument } from 'pdf-lib';

export default {
  components: {},
  computed: {
    selectedCount: function () {
      return this.smkItemList.filter((x) => x.selected).length;
    },
    topLeftDivWidth: function () {
      return `width: ${this.leftWidth}%;`;
    },
    topRightDivWidth: function () {
      return `width: ${100 - this.leftWidth}%;`;
    },

    documentTypeFilter: function () {
      const docTypeList = this.documentType.filter((doc) => !doc.hide);
      return docTypeList;
    },

    showPDF: function () {
      return this.selectedDocumentType && this.selectedDocumentType['name'] === 'PDF' && this.embedSrc;
    },
    pageOptions: function () {
      return Array.from({ length: this.totalPages }, (_, i) => ({
        Page: String(i + 1),
      }));
    },
    selectedPageCount: function () {
      if (!this.pageStartObj || !this.pageEndObj) return 0;

      const start = parseInt(this.pageStartObj.Page);
      const end = parseInt(this.pageEndObj.Page);

      return end - start + 1;
    },
    filteredSMKItemList: function () {
      let rows = this.smkItemList || [];

      // global search
      if (this.searchText && this.searchText.trim()) {
        const keyword = this.searchText.trim().toLowerCase();

        rows = rows.filter((row) => {
          return this.displayColumns.some((col) => {
            if (['select', 'seq', 'action'].includes(col.key)) return false;

            const val = this.getSearchableCellValue(row, col.key);
            return String(val || '')
              .toLowerCase()
              .includes(keyword);
          });
        });
      }

      // column filters
      rows = rows.filter((row) => {
        return this.displayColumns.every((col) => {
          const filterVal = (this.columnFilters[col.key] || '').trim().toLowerCase();
          if (!filterVal) return true;
          if (['select', 'seq', 'action'].includes(col.key)) return true;

          const val = this.getSearchableCellValue(row, col.key);
          return String(val || '')
            .toLowerCase()
            .includes(filterVal);
        });
      });

      return rows;
    },
    batchFieldOptions: function () {
      const vehicleKeys = [
        'Model',
        'ChassisNo',
        'EngineNo',
        'Brand',
        'EngineCapacityQlf',
        'EngineCapacityValue',
        'ManufactureDate',
      ];

      return Object.keys(this.fieldConfig)
        .filter((key) => {
          // if NOT vehicle template  hide vehicle fields
          if (!this.isVehicleTemplate && vehicleKeys.includes(key)) return false;
          return true;
        })
        .map((key) => ({
          key,
          label: this.fieldConfig[key].label,
        }));
    },
    selectedBatchFieldObj: {
      get() {
        return this.batchFieldOptions.find((x) => x.key === this.batchField) || null;
      },
      set(val) {
        this.batchField = val ? val.key : '';
      },
    },
    isVehicleTemplate: function () {
      return this.selectedTemplateType?.value === 'VEHICLE';
    },

    activeColumns: function () {
      const vehicleKeys = [
        'Model',
        'ChassisNo',
        'EngineNo',
        'Brand',
        'EngineCapacityQlf',
        'EngineCapacityValue',
        'ManufactureDate',
      ];

      return this.columns.filter((col) => {
        if (!this.isVehicleTemplate && vehicleKeys.includes(col.key)) return false;
        return true;
      });
    },
  },
  data: function () {
    return {
      showTopSection: true,
      lastCIItems: [],
      lastPLItems: [],
      lastMergedItems: [],
      lastSelectedSource: '',
      lastDetectedData: [],
      searchText: '',
      columnFilters: {},
      displayColumns: [],
      draggingColumnIndex: null,
      templateTypeList: [
        { label: 'GAIN', value: 'GAIN' },
        { label: 'VEHICLE', value: 'VEHICLE' },
      ],
      selectedTemplateType: { label: 'GAIN', value: 'GAIN' },
      columns: [
        { key: 'select', type: 'checkbox', width: 40 },
        { key: 'seq', label: '#', width: 30 },
        { key: 'Product', label: 'Product #' },
        { key: 'CountryOfOrigin', label: 'Country Of Origin' },
        { key: 'HSCode', label: 'Tariff Code', width: 160 },
        { key: 'StatisticalQty', label: 'Qty' },
        { key: 'StatisticalUOM', label: 'UOM', width: 120 },
        { key: 'DeclaredQty', label: 'Tariff Qty' },
        { key: 'DeclaredUOM', label: 'Tariff UOM', width: 120 },
        { key: 'UnitPrice', label: 'Unit Price' },
        { key: 'ItemAmount', label: 'Amount' },
        { key: 'ItemDescription', label: 'Item Description' },
        { key: 'CEPT', label: 'CEPT' },
        { key: 'Alcohol', label: 'Alcohol?' },
        { key: 'DutyQty', label: 'Duty Qty' },

        // vehicle only
        { key: 'Model', label: 'Model' },
        { key: 'ChassisNo', label: 'Chassis No' },
        { key: 'EngineNo', label: 'Engine No' },
        { key: 'Brand', label: 'Brand' },
        { key: 'EngineCapacityQlf', label: 'Engine Capacity Qlf', width: 170 },
        { key: 'EngineCapacityValue', label: 'Engine Capacity Value', width: 170 },
        { key: 'ManufactureDate', label: 'Manufacture Date' },

        { key: 'action', label: 'Delete', width: 120 },
      ],
      showBatchAddPopup: false,
      batchAddCount: '',
      savePopupButtons: [
        { text: 'Add', value: 'Add' },
        { text: 'Cancel', value: 'Cancel', color: 'lightgray' },
      ],
      selectAll: false,
      lastCheckedIndex: null,
      batchField: '',
      batchValue: '',
      //#region for batch edit
      fieldConfig: {
        Product: { type: 'text', label: 'Product #' },

        CountryOfOrigin: {
          type: 'dropdown',
          source: 'countryList',
          itemKey: 'Country Code',
          descKey: 'Country',
          label: 'CountryoFOrigin',
        },

        HSCode: {
          type: 'dropdown',
          source: 'tcList',
          itemKey: 'Tariff Code',
          descKey: 'Description',
          label: 'Tariff Code',
        },

        StatisticalQty: { type: 'number', label: 'Qty' },
        StatisticalUOM: {
          type: 'dropdown',
          source: 'uomList',
          itemKey: 'UOM Code',
          label: 'UOM',
        },
        DeclaredQty: { type: 'number', label: 'Tariff Qty' },
        DeclaredUOM: {
          type: 'dropdown',
          source: 'uomList',
          itemKey: 'UOM Code',
          label: 'Tariff UOM',
        },

        UnitPrice: { type: 'number', label: 'Unit Price' },
        ItemAmount: { type: 'number', label: 'Amount' },
        ItemDescription: { type: 'text', label: 'Item Description' },
        CEPT: { type: 'text', label: 'CEPT' },

        Alcohol: {
          type: 'dropdown',
          source: 'alcoholList',
          itemKey: 'Name',
          descKey: 'Code',
          label: 'Alcohol?',
        },
        DutyQty: { type: 'number', label: 'Duty Qty' },

        // vehicle only
        Model: { type: 'text', label: 'Model' },
        ChassisNo: { type: 'text', label: 'Chassis No' },
        EngineNo: { type: 'text', label: 'Engine No' },
        Brand: { type: 'text', label: 'Brand' },
        EngineCapacityQlf: { type: 'text', label: 'Engine Capacity Qlf' },
        EngineCapacityValue: { type: 'text', label: 'Engine Capacity Value' },
        ManufactureDate: { type: 'text', label: 'Manufacture Date' },
      },

      //#endregion

      leftWidth: 50, // percentage
      isResizing: false,
      pdfHidden: false,

      documentType: [
        { placeholder: 'CSV', name: 'CSV', type: ['.csv'], key: 'Import_CSV', hide: true },
        { placeholder: 'Excel', name: 'Excel', type: ['.xlsx', '.xls'], key: 'Import_Excel', hide: true },
        { placeholder: 'Text', name: 'Text', type: ['.txt'], key: 'Import_Text', hide: true },
        { placeholder: 'Doc AI (PDF)', name: 'PDF', type: ['.pdf'], key: 'Import_DocAI', hide: false },
      ],
      smkItemList: [],

      selectedDocumentType: null,

      importDoc: {
        docName: '',
        attachmentFile: [],
        filetype: '',
        original: [],
      },

      embedSrc: '',
      // scannedData: [],

      uploadedData: [], // Data that will show at the left table box (Uploaded Data table), data is exactly same as the data in the file uploaded by users
      importDataHeader: [],
      formattedUploadData: [], // Data used when export to CSV / revalidate. Data that are formatted and mapped into default template
      validatedData: [], // Data that is validated, will show error and warnings (where applicable)
      showValidatedDataTable: true,

      messageBoxTextList: [],
      messageBoxText: '',
      messageBoxType: '',

      showMappingPopup: false,
      customTemplateName: '',
      successMessages: [],
      errorMessages: [],

      //Custom Template Listing Popup
      selectedCustomTemplate: [], // use for "Custom Template Listing" popups
      generalInfoData: {
        countryList: [],
        uomList: [],
        tcList: [],
        alcoholList: [
          { Name: 'No', Code: 0 },
          { Name: 'Yes', Code: 1 },
        ],
      },
      totalPages: 0,
      pageStartObj: null,
      pageEndObj: null,
      showPageSelector: true,
      processorVersion: '',
    };
  },
  props: {},
  methods: {
    exportSMKItemExcel: async function () {
      const data = this.smkItemList.map((item) => {
        const clone = { ...item };
        delete clone._rowid;
        delete clone.id;
        delete clone.selected;
        delete clone.UnitPrice;

        // convert dropdown objects into strings
        Object.keys(clone).forEach((key) => {
          //console.log('key', key);
          if (clone[key] && typeof clone[key] === 'object') {
            const config = this.fieldConfig[key];

            // SPECIAL RULE for Alcohol → use descKey
            if (key === 'Alcohol' && config && config.type === 'dropdown') {
              clone[key] = clone[key][config.descKey] ?? '';
            } else if (config && config.type === 'dropdown') {
              clone[key] = clone[key][config.itemKey] ?? '';
            } else {
              // fallback for unexpected objects
              clone[key] = JSON.stringify(clone[key]);
            }
          }
        });
        return clone;
      });

      if (data.length === 0) {
        this.$showAlert('error', 'No data', 'No SMK Items to export');
        return;
      }
      const currentDateTime = new Date().formatString('dd/MM/yyyy HH:mm:ss');

      const exportName = `SMK_Import_Items_${currentDateTime}`;
      const templateType = 'SMKImportItem';
      await this.$jsonToExcel(exportName, data, templateType, null, false);
    },
    toggleSelectAll: function () {
      const targetRows = this.filteredSMKItemList;

      this.$fullscreenLoading(this.selectAll ? 'Selecting items...' : 'Unselecting items...');

      setTimeout(async () => {
        const CHUNK = 50;

        for (let i = 0; i < targetRows.length; i++) {
          this.$set(targetRows[i], 'selected', this.selectAll);

          if (i % CHUNK === 0) {
            await new Promise((r) => setTimeout(r, 0));
          }
        }

        this.$fullscreenLoading('');
      }, 0);
    },

    clearSelected: function () {
      this.selectAll = false;
      this.smkItemList.forEach((row) => (row.selected = false));
    },

    deleteSelected: async function () {
      const deleteSMKItem = await this.$showAlert(
        'warning',
        'SMK Item Delete',
        `Are you sure you want to delete ${this.selectedCount} selected items?`,
        [{ text: 'Delete' }, { text: 'Cancel' }],
      );

      if (deleteSMKItem !== 'Delete') return;

      this.$fullscreenLoading('Loading...');

      setTimeout(async () => {
        // chunked delete to keep UI responsive
        const remaining = [];
        const CHUNK = 50;

        for (let i = 0; i < this.smkItemList.length; i++) {
          if (!this.smkItemList[i].selected) {
            remaining.push(this.smkItemList[i]);
          }

          if (i % CHUNK === 0) {
            await new Promise((r) => setTimeout(r, 0));
          }
        }

        this.smkItemList = remaining;
        this.selectAll = false;

        this.$fullscreenLoading('');
      }, 0);
    },

    applyBatchEdit: function () {
      if (!this.batchField) return;
      const config = this.fieldConfig[this.batchField];

      this.smkItemList.forEach((row) => {
        if (!row.selected) return;

        // DROPDOWN uses object (InputQuery)
        if (config.type === 'dropdown') {
          row[this.batchField] = JSON.parse(JSON.stringify(this.batchValue));
        } else {
          row[this.batchField] = this.batchValue;
        }
      });

      this.$nextTick(() => {
        this.scrollToColumn(this.batchField);
      });
    },

    scrollToColumn: function (fieldKey) {
      const columns = this.displayColumns || this.columns;
      const index = columns.findIndex((col) => col.key === fieldKey);
      if (index === -1) return;

      const headerColumns = this.$el.querySelectorAll('.table-header .table-column');
      const target = headerColumns[index];
      if (!target) return;

      const scrollContainer = target.closest('.table-container');
      if (!scrollContainer) return;

      const targetLeft = target.offsetLeft;
      const targetWidth = target.offsetWidth;
      const containerWidth = scrollContainer.clientWidth;

      const newScrollLeft = targetLeft - containerWidth / 2 + targetWidth / 2;

      scrollContainer.scrollTo({
        left: Math.max(0, newScrollLeft),
        behavior: 'smooth',
      });
    },
    // SHIFT-CLICK SELECT (Excel style)
    shiftSelect: function (row, filteredIndex, event) {
      row.selected = !row.selected;

      if (event.shiftKey && this.lastCheckedIndex !== null) {
        const start = Math.min(filteredIndex, this.lastCheckedIndex);
        const end = Math.max(filteredIndex, this.lastCheckedIndex);
        const shouldSelect = row.selected;

        for (let i = start; i <= end; i++) {
          this.filteredSMKItemList[i].selected = shouldSelect;
        }
      }

      this.lastCheckedIndex = filteredIndex;
    },
    startResize: function (_e) {
      this.isResizing = true;

      const iframe = document.querySelector('.pdf-display');
      if (iframe) iframe.style.pointerEvents = 'none'; // disable iframe mouse capture

      window.addEventListener('mousemove', this.handleResize);
      window.addEventListener('mouseup', this.stopResize);

      document.body.style.userSelect = 'none'; // prevent text selection
    },

    handleResize: function (e) {
      if (!this.isResizing) return;

      const container = document.getElementById('top-section');
      const rect = container.getBoundingClientRect();

      let newLeftPercent = ((e.clientX - rect.left) / rect.width) * 100;

      // limits
      if (newLeftPercent < 10) newLeftPercent = 10;
      if (newLeftPercent > 90) newLeftPercent = 90;

      this.leftWidth = newLeftPercent;
    },

    stopResize: function () {
      this.isResizing = false;

      const iframe = document.querySelector('.pdf-display');
      if (iframe) iframe.style.pointerEvents = 'auto'; // restore iframe interaction

      window.removeEventListener('mousemove', this.handleResize);
      window.removeEventListener('mouseup', this.stopResize);
      document.body.style.userSelect = ''; // restore text selection
    },

    togglePDF: function () {
      this.pdfHidden = !this.pdfHidden;
      this.leftWidth = this.pdfHidden ? 0 : 50;
    },
    showMessage: function (type, text) {
      if (text) {
        this.messageBoxTextList.push(text);
      }
      this.messageBoxText = this.messageBoxTextList.join('<br>') || '';
      this.messageBoxType = type || '';
    },

    clearData: function () {
      this.uploadedData = [];
      this.validatedData = [];
      this.formattedUploadData = [];
      this.invTableHeader = '';
      this.importDataHeader = [];
      this.embedSrc = '';
      this.showMessage();
    },

    handleFileUpload: async function (file) {
      this.showMessage();
      this.messageBoxTextList = [];
      this.clearData();
      this.showPageSelector = true;

      if (file.length === 0) {
        this.processorVersion = '';
        return;
      }

      const uploadedFile = file[0];

      const filetype = `.${uploadedFile.name.split('.').at(-1)}`.toLowerCase();

      if (filetype !== '.pdf') {
        this.showMessage('error', 'Invalid file format. Please upload PDF only.');
        return;
      }

      this.importDoc.docName = uploadedFile.name;
      this.$forceUpdate();
      this.importDoc['original'] = uploadedFile;

      this.importDoc['filetype'] = filetype;
      this.importDoc['attachmentFile'] = await uploadedFile.toBase64(true);

      // preview
      this.embedSrc = URL.createObjectURL(uploadedFile);

      // detect total pages
      const pdfBytes = await uploadedFile.arrayBuffer();
      const pdfDoc = await PDFDocument.load(pdfBytes);

      this.totalPages = pdfDoc.getPageCount();
      if (this.totalPages === 1) {
        // No need for page selection if only 1 page, directly process the PDF
        await this.processPDF(uploadedFile);
        return;
      }
      // Set default dropdown selection
      this.pageStartObj = this.pageOptions[0];
      this.pageEndObj = this.pageOptions[this.pageOptions.length - 1];
    },

    processSelectedPages: async function () {
      if (!this.importDoc.original) return;

      const file = this.importDoc.original;

      const { PDFDocument } = await import('pdf-lib');

      const pdfBytes = await file.arrayBuffer();
      const srcDoc = await PDFDocument.load(pdfBytes);
      const newDoc = await PDFDocument.create();

      const startPage = this.pageStartObj ? parseInt(this.pageStartObj.Page) : null;
      const endPage = this.pageEndObj ? parseInt(this.pageEndObj.Page) : null;

      // validat page range
      if (!startPage || !endPage) {
        this.$showAlert('error', 'Invalid Page Range', 'Please enter valid page numbers.');
        return;
      }
      if (startPage < 1 || endPage < 1) {
        this.$showAlert('error', 'Invalid Page Range', 'Page numbers must start from 1.');
        return;
      }
      if (startPage > endPage) {
        this.$showAlert('error', 'Invalid Page Range', 'Start page cannot be greater than End page.');
        return;
      }
      if (endPage > this.totalPages) {
        this.$showAlert('error', 'Invalid Page Range', `This document only has ${this.totalPages} pages.`);
        return;
      }
      this.$fullscreenLoading('Processing Selected Pages');
      const start = startPage - 1;
      const end = endPage - 1;
      const pages = [];
      for (let i = start; i <= end; i++) {
        pages.push(i);
      }

      const copiedPages = await newDoc.copyPages(srcDoc, pages);
      copiedPages.forEach((p) => newDoc.addPage(p));

      const newPdfBytes = await newDoc.save();

      // Create new file
      const newFile = new File([newPdfBytes], 'selected_pages.pdf', {
        type: 'application/pdf',
      });

      // Update preview to ONLY selected pages
      this.embedSrc = URL.createObjectURL(newFile);

      // Process the sliced PDF
      await this.processPDF(newFile);
      this.showPageSelector = false;
      this.$fullscreenLoading();
    },

    handleFileDrop: async function (event) {
      event.preventDefault();

      const files = event.dataTransfer.files;
      if (files.length > 0) {
        await this.handleFileUpload(files);
      }
    },

    processPDF: async function (file) {
      this.processorVersion = '';
      const progressMessages = [
        'Processing PDF',
        'Reading document pages',
        'Identifying Commercial Invoice / Packing List',
        'Extracting header information',
        'Extracting item details',
        'Validating extracted values',
        'Finalizing structured output',
      ];

      const idleMessages = ['Populating data', 'Final checks in progress', 'Almost done'];

      let loadingIndex = 0;
      let isIdlePhase = false;
      let loadingStopped = false;
      let loadingTimeout = null;

      const runLoading = () => {
        if (loadingStopped) return;

        if (!isIdlePhase) {
          if (loadingIndex < progressMessages.length - 1) {
            loadingIndex++;
            this.$fullscreenLoading(progressMessages[loadingIndex]);

            // slower and slower as it goes
            const delay = Math.min(2500 + loadingIndex * 1500, 7000);
            loadingTimeout = setTimeout(runLoading, delay);
          } else {
            isIdlePhase = true;
            loadingIndex = 0;
            this.$fullscreenLoading(idleMessages[loadingIndex]);
            loadingTimeout = setTimeout(runLoading, 2200);
          }
        } else {
          loadingIndex = (loadingIndex + 1) % idleMessages.length;
          this.$fullscreenLoading(idleMessages[loadingIndex]);
          loadingTimeout = setTimeout(runLoading, 2200);
        }
      };

      this.$fullscreenLoading(progressMessages[0]);
      loadingTimeout = setTimeout(runLoading, 1200);

      const formData = new FormData();
      formData.append('file', file);

      try {
        const response = await Axios.post('/CIPLExtractor/ProcessFile', formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
        //console.log(response);

        const keyValueData = response.data.data.keyValue;
        this.processorVersion = response.data.processorVersion;
        this.showValidatedDataTable = false;
        this.uploadedData = keyValueData;
        this.formattedUploadData = keyValueData;

        this.$fullscreenLoading('Populating Data');
        // pass raw new structure
        await this.populateData(keyValueData);
        this.$nextTick(() => {
          setTimeout(() => {
            this.fitAllColumns();
          }, 0);
        });
      } catch (error) {
        let errMsg = 'Unknown error occurred';

        if (error.response) {
          if (typeof error.response.data === 'string') {
            errMsg = error.response.data;
          } else if (error.response.data?.error?.message) {
            errMsg = error.response.data.error.message;
          } else {
            errMsg = JSON.stringify(error.response.data);
          }
        } else if (error.request) {
          errMsg = 'No response from server';
        } else {
          errMsg = error.message;
        }

        //console.log('Full error:', error);

        this.$showAlert('error', 'An Error Occurred', errMsg);
      } finally {
        loadingStopped = true;
        clearTimeout(loadingTimeout);
        this.$fullscreenLoading();
      }
    },
    populateData: async function (data) {
      this.smkItemList = [];
      this.filteredPkgType = [];
      this.filteredItemCode = [];

      const ciItems = data.filter((x) => x.Key === 'Items_CommercialInvoice');
      const plItems = data.filter((x) => x.Key === 'Items');

      this.lastDetectedData = data;
      this.lastCIItems = JSON.parse(JSON.stringify(ciItems));
      this.lastPLItems = JSON.parse(JSON.stringify(plItems));
      this.lastMergedItems = [];

      let itemGroups = [];

      const canMerge = plItems.length === ciItems.length;

      // BOTH FOUND
      if (plItems.length && ciItems.length) {
        this.lastMergedItems = JSON.parse(JSON.stringify(this.mergeCIAndPL(ciItems, plItems)));

        const message =
          canMerge ?
            'Which item source would you like to use?'
          : 'Which item source would you like to use?\n\n(Merge disabled: item count mismatch between Commercial Invoice and Packing List)';

        const choice = await this.$showAlert('warning', 'Both Commercial Invoice and Packing List detected', message, [
          { text: 'Use Commercial Invoice' },
          { text: 'Use Packing List' },
          {
            text: canMerge ? 'Merge Both' : 'Merge Both (Unavailable)',
            disabled: !canMerge,
          },
        ]);

        if (choice === 'Use Packing List') {
          this.lastSelectedSource = 'PL';
          itemGroups = this.lastPLItems;
        } else if (choice === 'Use Commercial Invoice') {
          this.lastSelectedSource = 'CI';
          itemGroups = this.lastCIItems;
        } else {
          this.lastSelectedSource = 'MERGE';
          itemGroups = this.lastMergedItems;
        }
      } else if (plItems.length) {
        this.lastSelectedSource = 'PL';
        itemGroups = this.lastPLItems;
      } else if (ciItems.length) {
        this.lastSelectedSource = 'CI';
        itemGroups = this.lastCIItems;
      }

      this.applyItemGroupsToSMKList(itemGroups, data);
    },
    applyItemGroupsToSMKList: function (itemGroups, data) {
      this.smkItemList = [];

      const countryList = this.generalInfoData['countryList'];
      const tcList = this.generalInfoData['tcList'];
      const uomList = this.generalInfoData['uomList'];

      // 1) Process header values
      const countryItem = data.find((x) => x.Key === 'CountryOfOrigin'); // CountryOfOrigin
      let selectedCountry = null;
      if (countryItem) {
        const value = countryItem.Value;

        // normalize input and list for matching
        const normalized = value?.toString().trim().toUpperCase();
        const list = countryList;

        // try code first
        selectedCountry =
          list.getSelected(normalized, 'Country Code') ||
          // fallback: match by name
          list.find((c) => c['Country']?.toString().trim().toUpperCase() === normalized) ||
          null;
      }

      const alcoholItem = data.find((x) => x.Key === 'Alcohol'); // Alcohol
      let selectedAlcohol = null;
      if (alcoholItem) {
        const value = alcoholItem.Value;
        const list = this.generalInfoData['alcoholList'];

        selectedAlcohol = value === 'Yes' ? list[1] : list[0]; // default No
      }

      const getChildValue = (item, key) => {
        if (!item) return '';
        if (Array.isArray(item.Value)) {
          const found = item.Value.find((x) => x.Key === key);
          return found?.Value ?? '';
        }
        return '';
      };

      itemGroups.forEach((item) => {
        const hscodeRaw = getChildValue(item, 'HSCode');
        const uomRaw = getChildValue(item, 'DeclaredUOM') || getChildValue(item, 'StatisticalUOM');
        const countryRaw = getChildValue(item, 'CountryOfOrigin');

        const selectedHSCode =
          tcList.getSelected((hscodeRaw || '').toString().trim(), 'Tariff Code') ||
          (hscodeRaw ?
            {
              'Tariff Code': (hscodeRaw || '').toString().trim(), // if not found in list, still keep the raw value for user reference
            }
          : null);

        const selectedUOM =
          uomList.getSelected((uomRaw || '').toString().trim(), 'UOM Code') ||
          (uomRaw ?
            {
              'UOM Code': (uomRaw || '').toString().trim(), // if not found in list, still keep the raw value for user reference
            }
          : null);

        const selectedRowCountry =
          countryList.getSelected((countryRaw || '').toString().trim(), 'Country Code') ||
          countryList.find(
            (c) => c['Country']?.toString().trim().toUpperCase() === (countryRaw || '').toString().trim().toUpperCase(),
          ) ||
          selectedCountry;

        const row = {
          selected: false,
          Product: getChildValue(item, 'Product') || '',
          CountryOfOrigin: selectedRowCountry,
          HSCode: selectedHSCode,
          StatisticalQty: getChildValue(item, 'StatisticalQty') || getChildValue(item, 'DeclaredQty') || '',
          StatisticalUOM: selectedUOM,
          DeclaredQty: getChildValue(item, 'DeclaredQty') || '',
          DeclaredUOM: selectedUOM,
          UnitPrice: (getChildValue(item, 'UnitPrice') || '').toString().replaceAll(',', ''),
          ItemAmount: (getChildValue(item, 'ItemAmount') || '').toString().replaceAll(',', ''),
          ItemDescription: getChildValue(item, 'ItemDescription') || '',
          CEPT: getChildValue(item, 'CEPT') || '',
          Alcohol: selectedAlcohol,
          DutyQty: getChildValue(item, 'DutyQty') || '',

          Model: '',
          ChassisNo: '',
          EngineNo: '',
          Brand: '',
          EngineCapacityQlf: '',
          EngineCapacityValue: '',
          ManufactureDate: '',
        };

        if (this.selectedTemplateType?.value === 'VEHICLE') {
          row.Model = getChildValue(item, 'Vehicle_Model') || '';
          row.ChassisNo = getChildValue(item, 'Vehicle_ChassisNo') || '';
          row.EngineNo = getChildValue(item, 'Vehicle_EngineNo') || '';
          row.Brand = getChildValue(item, 'Vehicle_Brand') || '';
          row.EngineCapacityQlf = getChildValue(item, 'Vehicle_EngineCapacityQlf') || '';
          row.EngineCapacityValue = getChildValue(item, 'Vehicle_EngineCapacityValue') || '';
          row['ManufactureDate'] = this.parseManufactureDate(getChildValue(item, 'Vehicle_ManufactureDate'));
          if (!row.ItemDescription) {
            // If ItemDescription not exists, construct description Model + Capacity + Color
            row.ItemDescription = [row.Model, row.EngineCapacityValue, getChildValue(item, 'Vehicle_Color')]
              .filter(Boolean)
              .join(' ');
          }
        }
        this.smkItemList.push(row);
      });
    },
    reselectItemSource: async function () {
      if (!this.lastCIItems.length || !this.lastPLItems.length) return;

      const canMerge = this.lastCIItems.length === this.lastPLItems.length;
      const message =
        canMerge ?
          'Which item source would you like to use?'
        : 'Which item source would you like to use?\n\n(Merge disabled: item count mismatch between Commercial Invoice and Packing List)';

      const choice = await this.$showAlert('warning', 'Both Commercial Invoice and Packing List detected', message, [
        { text: 'Use Commercial Invoice' },
        { text: 'Use Packing List' },
        { text: canMerge ? 'Merge Both' : 'Merge Both (Unavailable)', disabled: !canMerge },
        { text: 'Cancel', color: 'lightgray' },
      ]);

      let itemGroups = [];

      if (choice === 'Use Packing List') {
        this.lastSelectedSource = 'PL';
        itemGroups = this.lastPLItems;
      } else if (choice === 'Use Commercial Invoice') {
        this.lastSelectedSource = 'CI';
        itemGroups = this.lastCIItems;
      } else if (choice === 'Merge Both') {
        this.lastSelectedSource = 'MERGE';
        itemGroups =
          this.lastMergedItems.length ? this.lastMergedItems : this.mergeCIAndPL(this.lastCIItems, this.lastPLItems);
      } else {
        return;
      }
      this.applyItemGroupsToSMKList(itemGroups, this.lastDetectedData);
    },
    mergeCIAndPL: function (ciItems, plItems) {
      const isVehicleTemplate = this.selectedTemplateType?.value === 'VEHICLE';

      if (!isVehicleTemplate) {
        return this.mergeCIAndPLNormal(ciItems, plItems);
      }

      return this.mergeCIAndPLVehicle(ciItems, plItems);
    },
    mergeCIAndPLNormal: function (ciItems, plItems) {
      const merged = [];
      const usedCI = new Set();
      plItems.forEach((pl) => {
        let bestMatch = null;
        let bestScore = 0;
        let bestIndex = -1;

        ciItems.forEach((ci, ciIndex) => {
          if (usedCI.has(ciIndex)) return;

          const score = this.calculateMatchScore(ci, pl);
          if (score > bestScore) {
            bestScore = score;
            bestMatch = ci;
            bestIndex = ciIndex;
          }
        });

        if (bestMatch && bestScore > 30) {
          usedCI.add(bestIndex);

          const mergedItem = {
            ...pl,
            Value: pl.Value.map((f) => ({ ...f })),
          };

          bestMatch.Value.forEach((f) => {
            const existingIndex = mergedItem.Value.findIndex((x) => x.Key === f.Key);
            if (existingIndex === -1) {
              mergedItem.Value.push({ ...f });
            } else {
              const existingValue = mergedItem.Value[existingIndex]?.Value;
              if (existingValue === '' || existingValue == null) {
                mergedItem.Value[existingIndex] = { ...f };
              }
            }
          });

          merged.push(mergedItem);
        } else {
          merged.push(pl);
        }
      });

      return merged;
    },
    mergeCIAndPLVehicle: function (ciItems, plItems) {
      const merged = [];
      const expandedCIItems = ciItems.length !== plItems.length ? this.expandCIItemsByQty(ciItems) : ciItems;
      const usedExpandedCI = new Set();

      plItems.forEach((pl) => {
        let bestMatch = null;
        let bestScore = 0;
        let bestIndex = -1;

        expandedCIItems.forEach((ci, ciIndex) => {
          if (usedExpandedCI.has(ciIndex)) return;

          let score = this.calculateVehicleMatchScore(ci, pl);
          if (score <= 30) {
            score = this.calculateVehicleMatchScoreFallBack(ci, pl);
          }
          if (score > bestScore) {
            bestScore = score;
            bestMatch = ci;
            bestIndex = ciIndex;
          }
        });

        if (bestMatch && bestScore >= 35) {
          usedExpandedCI.add(bestIndex);

          const mergedItem = {
            ...pl,
            Value: pl.Value.map((f) => ({ ...f })),
          };

          bestMatch.Value.forEach((f) => {
            const existingIndex = mergedItem.Value.findIndex((x) => x.Key === f.Key);
            if (existingIndex === -1) {
              mergedItem.Value.push({ ...f });
            } else {
              const existingValue = mergedItem.Value[existingIndex]?.Value;
              const newValue = f?.Value;

              if (f.Key === 'Vehicle_ManufactureDate') {
                const existingText = String(existingValue || '').trim();
                const newText = String(newValue || '').trim();

                if (!existingText || newText.length > existingText.length) {
                  mergedItem.Value[existingIndex] = { ...f };
                }
              } else if (existingValue === '' || existingValue == null) {
                mergedItem.Value[existingIndex] = { ...f };
              }
            }
          });

          merged.push(mergedItem);
        } else {
          merged.push(pl);
        }
      });

      return merged;
    },
    expandCIItemsByQty: function (ciItems) {
      // to tackle scenario where CI has 1 line with qty 10, but PL has 10 lines with qty 1
      const expanded = [];

      ciItems.forEach((ci, ciIndex) => {
        const qtyRaw = this.extractField(ci, 'DeclaredQty');
        const qty = parseInt(
          String(qtyRaw || '')
            .replace(/,/g, '')
            .trim(),
          10,
        );
        const unitPrice = this.extractField(ci, 'UnitPrice');
        const itemAmount = this.extractField(ci, 'ItemAmount');

        const safeQty = Number.isFinite(qty) && qty > 0 ? qty : 1;

        for (let i = 0; i < safeQty; i++) {
          const cloned = {
            ...ci,
            _sourceCIIndex: ciIndex,
            _splitIndex: i,
            Value: ci.Value.map((f) => ({ ...f })),
          };

          const declaredQtyField = cloned.Value.find((f) => f.Key === 'DeclaredQty');
          if (declaredQtyField) declaredQtyField.Value = '1';

          const itemAmountField = cloned.Value.find((f) => f.Key === 'ItemAmount');
          if (itemAmountField) {
            itemAmountField.Value = unitPrice || itemAmount || '';
          }

          expanded.push(cloned);
        }
      });

      return expanded;
    },
    normalizeChassisNo: function (value) {
      return String(value || '')
        .toUpperCase()
        .replace(/[^A-Z0-9]/g, '');
    },
    normalizeQty: function (value) {
      if (!value) return '';

      return value.toString().replace(/,/g, '').trim(); // remove commas and trim
    },
    normalizeProduct: function (code) {
      if (!code) return '';

      return code
        .toString()
        .toUpperCase()
        .replace(/[\n\r]/g, '') // remove line breaks
        .split('/')[0] // remove suffix
        .replace(/[^A-Z0-9]/g, '') // remove symbols
        .trim();
    },

    normalizeDesc: function (desc) {
      if (!desc) return '';

      return desc
        .toLowerCase()
        .replace(/[^a-z0-9\s]/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    },
    calculateProductSimilarity: function (a, b) {
      // match by character-level similarity
      if (!a || !b) return 0;

      a = a.toUpperCase();
      b = b.toUpperCase();

      let matches = 0;
      const len = Math.max(a.length, b.length);

      for (let i = 0; i < Math.min(a.length, b.length); i++) {
        if (a[i] === b[i]) matches++;
      }

      return matches / len;
    },
    calculateDescSimilarity: function (ciDesc, plDesc) {
      const ciWords = ciDesc.split(' ');
      const plWords = plDesc.split(' ');

      const ciSet = new Set(ciWords);
      const plSet = new Set(plWords);

      let matchCount = 0;

      ciSet.forEach((word) => {
        if (plSet.has(word)) matchCount++;
      });

      const maxWords = Math.max(ciSet.size, plSet.size);

      if (maxWords === 0) return 0;

      return matchCount / maxWords; // similarity ratio
    },

    extractField: function (item, key) {
      const field = item.Value.find((f) => f.Key === key);
      return field ? field.Value : '';
    },
    calculateMatchScore: function (ci, pl) {
      const ciProduct = this.normalizeProduct(this.extractField(ci, 'Product'));
      const plProduct = this.normalizeProduct(this.extractField(pl, 'Product'));

      const ciQty = this.normalizeQty(this.extractField(ci, 'DeclaredQty'));
      const plQty = this.normalizeQty(this.extractField(pl, 'DeclaredQty'));

      const ciDesc = this.normalizeDesc(this.extractField(ci, 'ItemDescription'));
      const plDesc = this.normalizeDesc(this.extractField(pl, 'ItemDescription'));
      // Start score at 0
      // Higher score = higher chance CI item and PL item are the same item
      let score = 0;

      // product match
      if (ciProduct && plProduct) {
        const similarity = this.calculateProductSimilarity(ciProduct, plProduct);

        if (similarity >= 0.9)
          score += 30; // Very close product match
        else if (similarity >= 0.7)
          score += 20; // Medium close product match
        else if (similarity >= 0.5) score += 10; // Partial product match
      }

      // qty match
      if (ciQty && plQty && ciQty === plQty) score += 50; // exact qty match + 50 score

      // description fallback
      if (ciDesc && plDesc) {
        // This helps when Product alone is not enough
        const similarity = this.calculateDescSimilarity(ciDesc, plDesc);

        if (similarity >= 0.7) score += 30;
        else if (similarity >= 0.5) score += 20;
      }

      return score;
    },
    calculateVehicleMatchScore: function (ci, pl) {
      // For VEHICLE template, compare more vehicle-specific fields
      // because model/qty alone is often not enough
      const ciModel = this.normalizeProduct(this.extractField(ci, 'Vehicle_Model'));
      const plModel = this.normalizeProduct(this.extractField(pl, 'Vehicle_Model'));

      const ciDesc = this.normalizeDesc(this.extractField(ci, 'ItemDescription'));
      const plDesc = this.normalizeDesc(this.extractField(pl, 'ItemDescription'));

      const ciQty = this.normalizeQty(this.extractField(ci, 'DeclaredQty'));
      const plQty = this.normalizeQty(this.extractField(pl, 'DeclaredQty'));

      const ciChassis = this.normalizeChassisNo(this.extractField(ci, 'Vehicle_ChassisNo'));
      const plChassis = this.normalizeChassisNo(this.extractField(pl, 'Vehicle_ChassisNo'));

      const ciEngine = this.normalizeProduct(this.extractField(ci, 'Vehicle_EngineNo'));
      const plEngine = this.normalizeProduct(this.extractField(pl, 'Vehicle_EngineNo'));

      let score = 0;
      // If chassis number is exactly the same, give highest score
      // because this usually identifies the exact same vehicle
      if (ciChassis && plChassis && ciChassis === plChassis) score += 100;
      if (ciEngine && plEngine && ciEngine === plEngine) score += 80; // If engine number is exactly the same, give high score

      if (ciModel && plModel) {
        const modelSimilarity = this.calculateProductSimilarity(ciModel, plModel);
        if (modelSimilarity >= 0.95)
          score += 30; // Almost exact same model
        else if (modelSimilarity >= 0.8)
          score += 20; // Strong model match
        else if (modelSimilarity >= 0.6) score += 10; // Partial model match
      }

      if (ciDesc && plDesc) {
        const descSimilarity = this.calculateDescSimilarity(ciDesc, plDesc);
        if (descSimilarity >= 0.85)
          score += 40; // Very strong description match
        else if (descSimilarity >= 0.7)
          score += 25; // Strong description match
        else if (descSimilarity >= 0.5) score += 10; // Partial description match
      }

      if (ciQty && plQty && ciQty === plQty) score += 5; // Qty is only a small bonus in vehicle matching, because sometimes the same vehicle can be split into multiple lines in PL

      return score;
    },
    calculateVehicleMatchScoreFallBack: function (ci, pl) {
      const ciModel = this.normalizeProduct(this.extractField(ci, 'Vehicle_Model'));
      const plModel = this.normalizeProduct(this.extractField(pl, 'Vehicle_Model') || this.extractField(pl, 'Model'));

      const ciQty = this.normalizeQty(this.extractField(ci, 'DeclaredQty'));
      const plQty = this.normalizeQty(this.extractField(pl, 'DeclaredQty'));

      const ciChassis = this.normalizeChassisNo(this.extractField(ci, 'Vehicle_ChassisNo'));
      const plChassis = this.normalizeChassisNo(
        this.extractField(pl, 'Vehicle_ChassisNo') || this.extractField(pl, 'FrameNumber'),
      );

      const ciEngine = this.normalizeProduct(this.extractField(ci, 'Vehicle_EngineNo'));
      const plEngine = this.normalizeProduct(
        this.extractField(pl, 'Vehicle_EngineNo') || this.extractField(pl, 'EngineNo'),
      );

      // fallback CL description:
      // if ItemDescription is not returned, try to match by Model + CAP + Color
      let ciDescRaw = this.extractField(ci, 'ItemDescription');
      if (!ciDescRaw) {
        ciDescRaw = [
          this.extractField(pl, 'Vehicle_Model'),
          this.extractField(pl, 'Vehicle_EngineCapacityValue'),
          this.extractField(pl, 'Vehicle_Color'),
        ]
          .filter(Boolean)
          .join(' ');
      }
      const ciDesc = this.normalizeDesc(ciDescRaw);

      // fallback PL description:
      // match description to Model + CAP + Color
      const plDescRaw = [
        this.extractField(pl, 'Vehicle_Model'),
        this.extractField(pl, 'Vehicle_EngineCapacityValue'),
        this.extractField(pl, 'Vehicle_Color'),
      ]
        .filter(Boolean)
        .join(' ');
      const plDesc = this.normalizeDesc(plDescRaw);

      let score = 0;

      if (ciChassis && plChassis && ciChassis === plChassis) score += 100;
      if (ciEngine && plEngine && ciEngine === plEngine) score += 80;

      if (ciModel && plModel) {
        const modelSimilarity = this.calculateProductSimilarity(ciModel, plModel);
        if (modelSimilarity >= 0.95) score += 20;
        else if (modelSimilarity >= 0.8) score += 30;
        else if (modelSimilarity >= 0.6) score += 10;
      }

      if (ciDesc && plDesc) {
        const descSimilarity = this.calculateDescSimilarity(ciDesc, plDesc);
        if (descSimilarity >= 0.85) score += 40;
        else if (descSimilarity >= 0.7) score += 35;
        else if (descSimilarity >= 0.5) score += 10;
      }

      if (ciQty && plQty && ciQty === plQty) score += 5;

      return score;
    },
    addSMKItem: function () {
      this.smkItemList.push({
        selected: false,
        Product: '',
        CountryOfOrigin: null,
        HSCode: null,
        StatisticalQty: '',
        StatisticalUOM: null,
        DeclaredQty: '',
        DeclaredUOM: null,
        ItemAmount: '',
        ItemDescription: '',
        UnitPrice: '',
        CEPT: '',
        Alcohol: null,
        DutyQty: '',

        Model: '',
        ChassisNo: '',
        EngineNo: '',
        Brand: '',
        EngineCapacityQlf: '',
        EngineCapacityValue: '',
        ManufactureDate: '',
      });
    },
    openBatchAddPopup: function () {
      this.batchAddCount = '';
      this.showBatchAddPopup = true;
    },
    batchAddPopupButtonClicked: async function (buttonValue) {
      if (buttonValue !== 'Add') {
        this.showBatchAddPopup = false;
        return;
      }

      const count = parseInt(this.batchAddCount);
      if (!count || count <= 0) {
        await this.$showAlert('error', 'Invalid Number', 'Please enter a valid number', [{ text: 'OK' }]);
        return;
      }

      this.showBatchAddPopup = false;

      await this.$nextTick();

      await this.batchAddSMKItem(count);
    },
    batchAddSMKItem: async function (count) {
      this.$fullscreenLoading('Adding SMK Items...');
      await this.$nextTick();

      setTimeout(async () => {
        const CHUNK = 50;

        for (let i = 0; i < count; i++) {
          this.addSMKItem();

          if (i % CHUNK === 0) {
            await new Promise((r) => setTimeout(r, 0));
          }
        }

        this.$fullscreenLoading('');
      }, 0);
    },

    deleteSMKItem: function (index) {
      this.smkItemList.splice(index, 1);
    },
    deleteSMKItemAll: async function () {
      const deleteSMKItem = await this.$showAlert(
        'warning',
        'SMK Item Delete',
        `Are you sure you want to delete all items ?`,
        [{ text: 'Delete' }, { text: 'Cancel' }],
      );

      if (deleteSMKItem === 'Delete') {
        this.smkItemList.splice(0, this.smkItemList.length);
      }
    },
    isFreeText: function (index, fieldKey, list, listKey) {
      const codeObj = this.smkItemList[index][fieldKey];
      if (!codeObj || !codeObj[listKey]) return true;

      return !list.some((item) => item[listKey] === codeObj[listKey]);
    },
    selectedHSCode: function (index) {
      // select Tariff Code will auto populate Tariff UOM
      const hscodeUOM = this.smkItemList[index]?.HSCode?.UOM || '';
      const valueToMatch = (hscodeUOM || '').toString().trim();
      // Match against uomList
      const selected = this.generalInfoData['uomList'].getSelected(valueToMatch, 'UOM Code') || null;
      // Assign to DeclaredUOM
      this.smkItemList[index]['DeclaredUOM'] = selected;
      this.isFreeText(index, 'HSCode', this.generalInfoData.tcList, 'Tariff Code');
    },
    // updateItemAmount(index, changedField) {
    //   const qty = parseFloat(this.smkItemList[index]['StatisticalQty']) || 0;
    //   const price = parseFloat(this.smkItemList[index]['UnitPrice']) || 0;
    //   const amount = parseFloat(this.smkItemList[index]['ItemAmount']) || 0;

    //   if (changedField === 'qty') {
    //     // qty changed → recalc unit price using existing amount
    //     if (qty === 0) {
    //       this.smkItemList[index]['UnitPrice'] = '0';
    //     } else {
    //       this.smkItemList[index]['UnitPrice'] = (amount / qty).toString();
    //     }
    //   }

    //   if (changedField === 'price') {
    //     // price changed → recalc amount
    //     this.smkItemList[index]['ItemAmount'] = (qty * price).toString();
    //   }
    // },
    startColResize: function (e, colIndex) {
      const colEl = e.target.closest('.table-column');
      if (!colEl) return;

      const startX = e.pageX;
      const startWidth = colEl.offsetWidth;

      const onMove = (ev) => {
        const newWidth = startWidth + (ev.pageX - startX);
        if (newWidth < 60) return;

        this.$set(this.displayColumns, colIndex, {
          ...this.displayColumns[colIndex],
          width: newWidth,
        });
      };

      const onUp = () => {
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
        document.body.style.userSelect = '';
        document.body.style.cursor = '';
      };

      document.body.style.userSelect = 'none';
      document.body.style.cursor = 'col-resize';

      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onUp);
    },
    autoFit: function (e, colIndex) {
      const colEl = e.currentTarget;
      const rows = this.$el.querySelectorAll('.smk-edit-table .table-row');

      let maxWidth = 60;

      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      rows.forEach((row) => {
        const cell = row.children[colIndex];
        if (!cell) return;

        const input = cell.querySelector('input, textarea');
        let text = '';

        if (input) {
          text = input.value || input.placeholder || '';
        } else {
          text = cell.innerText || '';
        }

        const style = window.getComputedStyle(cell);
        ctx.font = `${style.fontSize} ${style.fontFamily}`;

        const textWidth = ctx.measureText(text).width + 30;
        maxWidth = Math.max(maxWidth, textWidth);
      });

      // also consider header text
      const headerText = colEl.innerText || '';
      const headerStyle = window.getComputedStyle(colEl);
      ctx.font = `${headerStyle.fontSize} ${headerStyle.fontFamily}`;
      maxWidth = Math.max(maxWidth, ctx.measureText(headerText).width + 30);

      if (maxWidth < 60) maxWidth = 60;

      this.$set(this.displayColumns, colIndex, {
        ...this.displayColumns[colIndex],
        width: Math.ceil(maxWidth),
      });
    },
    fitAllColumns: function () {
      this.$nextTick(() => {
        const headerColumns = this.$el.querySelectorAll('.table-header .table-column');
        const rows = this.filteredSMKItemList || this.smkItemList || [];

        if (!headerColumns.length || !rows.length) return;

        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        const getRowCellText = (row, colKey) => {
          const value = row[colKey];
          if (value == null) return '';

          if (typeof value === 'object') {
            const config = this.fieldConfig[colKey];
            if (config && config.type === 'dropdown') {
              return String(value[config.descKey] || value[config.itemKey] || '').trim();
            }
            return '';
          }

          return String(value).trim();
        };

        this.displayColumns.forEach((col, colIndex) => {
          if (['select', 'seq', 'action'].includes(col.key)) return;

          let maxWidth = col.width || 60;

          rows.forEach((row) => {
            const text = getRowCellText(row, col.key);
            if (!text) return;

            const headerEl = headerColumns[colIndex];
            const style = headerEl ? window.getComputedStyle(headerEl) : null;
            if (style) {
              ctx.font = `${style.fontSize} ${style.fontFamily}`;
            }

            const textWidth = ctx.measureText(text).width + 30;
            if (textWidth > maxWidth) {
              maxWidth = textWidth;
            }
          });

          const headerEl = headerColumns[colIndex];
          const headerText = headerEl ? (headerEl.innerText || '').trim() : '';
          if (headerEl && headerText) {
            const headerStyle = window.getComputedStyle(headerEl);
            ctx.font = `${headerStyle.fontSize} ${headerStyle.fontFamily}`;
            const headerWidth = ctx.measureText(headerText).width + 30;
            if (headerWidth > maxWidth) {
              maxWidth = headerWidth;
            }
          }

          if (maxWidth > 350) maxWidth = 350;

          // only expand
          if (maxWidth > (col.width || 60)) {
            this.$set(this.displayColumns, colIndex, {
              ...this.displayColumns[colIndex],
              width: Math.ceil(maxWidth),
            });
          }
        });
      });
    },
    initColumnFilters: function () {
      const obj = {};
      (this.displayColumns || []).forEach((col) => {
        obj[col.key] = this.columnFilters[col.key] || '';
      });
      this.columnFilters = obj;
    },

    getSearchableCellValue: function (row, key) {
      const value = row[key];

      if (value == null) return '';

      // if InputQuery stores object
      if (typeof value === 'object') {
        return (
          value['Tariff Code'] ||
          value['UOM Code'] ||
          value['Country Code'] ||
          value['Country'] ||
          value['Name'] ||
          value.label ||
          value.value ||
          ''
        );
      }

      return value;
    },

    onColumnDragStart: function (index) {
      this.draggingColumnIndex = index;
    },

    onColumnDrop: function (dropIndex) {
      const dragIndex = this.draggingColumnIndex;
      if (dragIndex === null || dragIndex === dropIndex) return;

      const cols = [...this.displayColumns];
      const dragged = cols.splice(dragIndex, 1)[0];
      cols.splice(dropIndex, 0, dragged);

      this.displayColumns = cols;
      this.draggingColumnIndex = null;
    },

    deleteSMKItemByRow: function (row) {
      const index = this.smkItemList.indexOf(row);
      if (index !== -1) this.deleteSMKItem(index);
    },

    isFreeTextByRow: function (row, key, list, compareKey) {
      const value = row[key];

      let raw = '';

      if (typeof value === 'object' && value !== null) {
        raw = value[compareKey] || value.Name || value.value || '';
      } else {
        raw = value || '';
      }

      const normalized = String(raw).trim().toUpperCase();

      // empty also count as warning
      if (!normalized) return true;

      return !list.some((item) => {
        const itemVal = String(item[compareKey] || '')
          .trim()
          .toUpperCase();

        return itemVal === normalized;
      });
    },

    selectedHSCodeByRow: function (row) {
      const index = this.smkItemList.indexOf(row);
      if (index !== -1) this.selectedHSCode(index);
    },
    isYYYYMMDD: function (value) {
      if (!value) return true;

      const str = String(value).trim();
      if (!/^\d{4}-\d{2}-\d{2}$/.test(str)) return false;

      const date = new Date(str);
      if (isNaN(date.getTime())) return false;

      const [y, m, d] = str.split('-').map(Number);

      return date.getUTCFullYear() === y && date.getUTCMonth() + 1 === m && date.getUTCDate() === d;
    },
    parseManufactureDate: function (value) {
      if (!value) return '';

      const raw = String(value).trim();
      if (!raw) return '';

      // already full ISO date
      if (/^\d{4}-\d{2}-\d{2}$/.test(raw)) return raw;

      // dd/MM/yyyy or d/M/yyyy
      let match = raw.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
      if (match) {
        const [, d, m, y] = match;
        return `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
      }

      // dd-MM-yyyy or d-M-yyyy
      match = raw.match(/^(\d{1,2})-(\d{1,2})-(\d{4})$/);
      if (match) {
        const [, d, m, y] = match;
        return `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
      }

      // MMM yyyy / MMMM yyyy -> default day = 1
      match = raw.match(/^([A-Za-z]{3,9})\s+(\d{4})$/);
      if (match) {
        const [, monthText, year] = match;
        const monthMap = {
          jan: '01',
          feb: '02',
          mar: '03',
          apr: '04',
          may: '05',
          jun: '06',
          jul: '07',
          aug: '08',
          sep: '09',
          sept: '09',
          oct: '10',
          nov: '11',
          dec: '12',
        };

        const month = monthMap[monthText.toLowerCase().slice(0, 4)] || monthMap[monthText.toLowerCase().slice(0, 3)];
        if (month) return `${year}-${month}-01`;
      }

      // let JS try last
      const dt = new Date(raw);
      if (!isNaN(dt.getTime())) {
        const y = dt.getFullYear();
        const m = String(dt.getMonth() + 1).padStart(2, '0');
        const d = String(dt.getDate()).padStart(2, '0');
        return `${y}-${m}-${d}`;
      }

      return '';
    },
  },

  async mounted() {
    this.$refs['doctype'].setFocus();

    const mountedPromises = [];
    let mountedPromisesFulfilledCount = 0;

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'country' }).then((result) => {
        this.generalInfoData['countryList'] = result;
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'UOM' }).then((result) => {
        this.generalInfoData['uomList'] = result;
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    mountedPromises.push(
      this.$apiCallV2('/Master/GetListMaster', { masterfile: 'SMKTC' }).then((result) => {
        this.generalInfoData['tcList'] = result;
        this.$topLoading(++mountedPromisesFulfilledCount / mountedPromises.length);
      }),
    );

    //default select DocAI document type
    this.selectedDocumentType = this.documentType?.getSelected('Import_DocAI', 'key') || [];

    await Promise.allSettled(mountedPromises);

    const fileInput = document.getElementById('file-input');
    fileInput.addEventListener('dragover', (event) => {
      event.preventDefault();
    });

    fileInput.addEventListener('drop', this.handleFileDrop);

    //#region pane resizer events
    const resizer = document.getElementById('resizer-x');
    const leftPane = document.getElementById('left-pane');
    const rightPane = document.getElementById('right-pane');

    let isDragging = false;

    resizer.addEventListener('mousedown', () => {
      isDragging = true;
      document.body.style.userSelect = 'none';
    });

    document.addEventListener('mousemove', (e) => {
      if (!isDragging) return;

      const totalWidth = this.$el.querySelector('.top-div').offsetWidth;
      let newLeftWidth = e.clientX;

      // Minimum limits
      if (newLeftWidth < 100) newLeftWidth = 100;
      if (newLeftWidth > totalWidth - 150) newLeftWidth = totalWidth - 150;

      leftPane.style.width = newLeftWidth + 'px';
      rightPane.style.width = totalWidth - newLeftWidth - 6 + 'px'; // minus divider width
    });

    document.addEventListener('mouseup', () => {
      isDragging = false;
      document.body.style.userSelect = '';
    });

    // Double click → collapse left pane
    resizer.addEventListener('dblclick', () => {
      if (leftPane.style.width === '0px') {
        leftPane.style.width = '50%';
        rightPane.style.width = '50%';
      } else {
        leftPane.style.width = '0px';
        rightPane.style.width = '100%';
      }
    });
    //#endregion

    this.displayColumns = this.activeColumns.map((x) => ({ ...x }));
    this.initColumnFilters();
  },
  watch: {
    uploadedData: {
      deep: true,
      handler: function (val) {
        if (val.length == 0) {
          this.validatedData = [];
          this.formattedUploadData = [];
        }
      },
    },
    batchField(newField) {
      if (!newField) {
        this.batchValue = null;
        return;
      }

      const type = this.fieldConfig[newField].type;

      if (type === 'text' || type === 'number') {
        this.batchValue = ''; // clear input
      } else if (type === 'dropdown') {
        this.batchValue = null; // clear dropdown object
      }
    },

    showMappingPopup: function (val) {
      if (!val) {
        this.selectedCustomTemplate = [];
        this.successMessages = [];
        this.errorMessages = [];
        this.customTemplateName = '';
      }
    },

    selectedTemplateType: {
      deep: true,
      handler() {
        this.displayColumns = this.activeColumns.map((x) => ({ ...x }));
        this.initColumnFilters();
      },
    },

    columns: {
      deep: true,
      handler() {
        this.displayColumns = this.activeColumns.map((x) => ({ ...x }));
        this.initColumnFilters();
      },
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/css/all.scss';

.import-main {
  padding: 10px 45px;
  padding-right: 20px;
  font-size: 12px;
  width: 100%;
  display: flex;
  flex-direction: column;
  height: calc(100vh - #{$top-nav-height});
  overflow: hidden;

  .top-section {
    background-color: white;
    border-radius: 5px;
    padding: 5px;
    height: max-content;

    .file-input {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      width: 30%;
    }
  }

  .message-container {
    width: 100%;
    height: auto;
    overflow: auto;
    padding: 5px;
    flex-grow: 1;
    margin-left: 20px;
  }

  > .bottom-section {
    align-items: center;
    margin-top: 5px;
    width: 100%;
    height: calc(100% - #{$top-nav-height});
    flex: 1;
    min-height: 0;
    overflow: hidden;

    .top-div {
      height: 100%;
      flex: none;
      display: flex;
      overflow: visible;

      .top-left-div .top-right-div {
        overflow: auto;
        width: 50%;
        height: 100%;
      }
    }

    .bottom-div {
      height: 25%;
      flex: none;
      overflow: visible;
    }

    .table-container {
      width: 100%;
      height: 100%;
      padding: 5px;
      background-color: white;
      border-radius: 5px;
      overflow-y: auto;
      overflow-x: auto;
      position: relative;
    }
  }

  .col-resizer {
    position: absolute;
    right: 0;
    top: 0;
    width: 6px;
    height: 100%;
    cursor: ew-resize;
    user-select: none;
  }

  .col-resizer:hover {
    background: rgba(0, 0, 0, 0.15);
  }

  .action {
    width: 120px;
    text-align: center;
  }

  .col.action {
    width: 120px;
  }

  .smk-wrapper {
    position: relative;
    overflow: visible;
  }

  .add-button-container {
    padding: 2px;
    display: flex;
    justify-content: center;
    /* justify-content: flex-end;  */
    gap: 5px;
    position: sticky;
    left: 0;
    bottom: 0;
    background: white;
  }

  .add-item-btn {
    margin-bottom: 10px;
    padding: 4px 10px;
    background-color: #4caf50;
    color: white;
    border: none;
    cursor: pointer;
    width: 100%;
    text-align: center;
  }

  .deleteall-item-btn {
    margin-bottom: 10px;
    padding: 4px 10px;
    background-color: #f44336;
    color: white;
    border: none;
    cursor: pointer;
    text-align: center;
  }
  .title {
    font-weight: bold;
    font-size: 1.2em;
    margin-right: 10px;
  }

  .select-col {
    width: 40px;
    min-width: 40px;
    max-width: 40px;
    text-align: center;
    padding: 2px 5px;
  }

  .smk-header-row.blue-theme > th {
    background-color: #535cda !important;
    color: white !important;
    position: sticky;
    top: 0;
    z-index: 5;
  }

  .blue-theme-row-selected > *:not(button) {
    background-color: rgb(170, 170, 255) !important;
    color: white !important;
  }

  .sticky-left {
    position: sticky;
    left: 0;
    z-index: 3;
    background: white;
  }

  .sticky-top {
    position: sticky;
    top: 0;
    z-index: 10;
  }

  .batch-panel {
    position: sticky;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    gap: 10px;
    background: #f0f0ff;
    padding: 8px 12px;
    border-bottom: 1px solid #c5c5ff;
    height: var(--batch-panel-height);
  }

  .batch-panel button {
    padding: 5px 12px;
    cursor: pointer;
  }
}

.resizer-x {
  width: 6px;
  background: #ccc;
  cursor: col-resize;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.resizer-y {
  height: 5px;
  cursor: ns-resize;
}

.collapse-btn {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  width: 22px;
  height: 22px;
  z-index: 1;
  border-radius: 4px;
  border: 1px solid #888;
  background: white;
  cursor: pointer;
  font-size: 12px;
  padding: 0;
  pointer-events: auto;
}
.collapse-btn:hover {
  background: #f0f0f0;
}

.pdf-display {
  height: 100%;
  width: 100%;
  margin: 0;
  border: 0px;
  margin-bottom: 10px;
  transform: none;
}

.pdf-guidance {
  background: #f5f7ff;
  border-left: 4px solid #535cda;
  padding: 6px 10px;
  font-size: 12px;
  margin-bottom: 6px;
}

.page-selector {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
}

.page-count {
  margin-left: 6px;
  color: #555;
  font-size: 12px;
}

.user-instructions {
  height: 100%;
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  font-size: 20px;
}

.column-highlight {
  animation: highlightFade 2s ease;
}

@keyframes highlightFade {
  0% {
    background-color: #fff4a3;
  }
  100% {
    background-color: transparent;
  }
}

.smk-title-row {
  display: flex;
  align-items: center;
  margin-bottom: 6px;
}

.title {
  font-weight: bold;
  font-size: 1.2em;
  margin-right: 10px;
}

/* table shell */
.smk-edit-table.table-box-main {
  background-color: #fff;
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: visible;
}

.smk-edit-table .top-block {
  min-height: 34px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 8px;
  border: 1px solid #d8dcff;
  border-bottom: none;
  background: #fff;
  position: sticky;
  left: 0;
  top: 0;
  width: 100%;
}

.smk-edit-table .right-section,
.smk-edit-table .left-section {
  display: flex;
  align-items: center;
  gap: 8px;
}

.table-search {
  height: 24px;
  min-width: 220px;
  padding: 0 8px;
  border: 1px solid #cfd4ff;
  outline: none;
  box-sizing: border-box;
  font-size: 12px;
}

/* scroll area */
.smk-edit-table .table-block {
  position: relative;
  overflow-x: visible;
  overflow-y: visible;
  z-index: 1;
  border: 1px solid #d8dcff;
  background: #fff;
}

/* header */
.smk-edit-table .table-header {
  display: flex;
  position: sticky;
  top: var(--batch-panel-height);
  z-index: 30;
  width: max-content;
  min-width: 100%;
}

.smk-edit-table .table-column {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  position: relative;
  box-sizing: border-box;
  border-right: 1px solid white;
  background-color: #535cda;
  color: #fff;
  overflow: visible;
}

.smk-edit-table .title-block {
  height: 24px;
  min-height: 24px;
  display: flex;
  align-items: center;
  padding: 0 4px;
  font-weight: 600;
  font-size: 12px;
  user-select: none;
  cursor: move;
  white-space: nowrap;
  justify-content: center;
}

.smk-edit-table .filter-block {
  padding: 2px 3px 3px;
  background: #535cda;
}

.smk-edit-table .column-filter {
  width: 100%;
  height: 20px;
  border: none;
  outline: none;
  padding: 0 4px;
  box-sizing: border-box;
  font-size: 11px;
}

/* rows */
.smk-edit-table .table-row {
  display: flex;
  overflow: visible;
  width: max-content;
  min-width: 100%;
}

.smk-edit-table .row-data {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  height: 32px;
  min-height: 32px;
  padding: 1px 3px;
  box-sizing: border-box;
  border-right: 1px solid rgba(128, 128, 128, 0.5);
  border-bottom: 1px solid #d6daf0;
  background: transparent;
  overflow: visible;
  position: relative;
}

.smk-edit-table .table-row .select-col.sticky-column {
  background: #fff !important;
}

.smk-edit-table .blue-theme-row:nth-child(even) > .select-col.sticky-column {
  background: #e2e4ff !important;
}

.smk-edit-table .blue-theme-row:hover > .select-col.sticky-column {
  background: rgb(170, 170, 255) !important;
}

.smk-edit-table .blue-theme-row-selected > .select-col.sticky-column {
  background: rgb(110, 110, 255) !important;
  color: #fff !important;
}

.smk-edit-table .blue-theme-row-selected:nth-child(even) > .select-col.sticky-column {
  background: rgb(110, 110, 255) !important;
  color: #fff !important;
}

.smk-edit-table .blue-theme-row-selected:hover > .select-col.sticky-column {
  background: rgb(140, 140, 255) !important;
  color: #fff !important;
}

/* sticky first column */
.smk-edit-table .sticky-column {
  position: sticky;
  left: 0;
  z-index: 20;
}

.smk-edit-table .table-header .sticky-column {
  z-index: 35;
  background-color: #535cda;
}

.smk-edit-table .table-row .sticky-column {
  background: inherit;
  background: white !important;
}

.smk-edit-table .table-row:nth-child(even) .sticky-column {
  background: #e2e4ff !important;
}

/* special column widths */
.smk-edit-table .select-col {
  min-width: 40px;
  max-width: 40px;
  justify-content: center;
  padding: 0 2px;
}

.smk-edit-table .seq-col {
  min-width: 50px;
  max-width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.smk-edit-table .action-col {
  min-width: 120px;
  max-width: 120px;
  justify-content: center;
}

.smk-edit-table .input-with-icon {
  gap: 4px;
}

.smk-edit-table .input-with-icon > *:first-child {
  flex-shrink: 0;
}

.big-checkbox {
  width: 18px;
  height: 18px;
  vertical-align: middle;
}

.smk-edit-table .row-data button {
  height: 22px;
  padding: 0 10px;
  border: 1px solid #cfd4ff;
  background: white;
  cursor: pointer;
  font-size: 12px;
}

.add-button-container {
  padding: 4px 2px;
  display: flex;
  justify-content: center;
  gap: 5px;
  position: sticky;
  left: 0;
  bottom: 0;
  background: white;
}

.add-item-btn {
  margin-bottom: 10px;
  padding: 4px 10px;
  background-color: #4caf50;
  color: white;
  border: none;
  cursor: pointer;
  width: 100%;
  text-align: center;
}

.deleteall-item-btn {
  margin-bottom: 10px;
  padding: 4px 10px;
  background-color: #f44336;
  color: white;
  border: none;
  cursor: pointer;
  text-align: center;
}

.table-container.top-right-div {
  overflow: visible;
  --batch-panel-height: 0px;
}

.table-container.top-right-div.has-batch-panel {
  --batch-panel-height: 48px;
}

.top-right-div ::v-deep .table-box-main > .bottom-block > .bottom-content > .bottom-spacer {
  width: auto !important;
  flex: 1 1 auto;
  min-width: 0;
}

.top-section-wrapper {
  position: relative;
  width: 100%;
}

.collapse-top-section {
  position: absolute;
  right: 10px;
  bottom: -10px;
  cursor: pointer;
  transition: transform 0.2s ease;
  z-index: 10;
  background: white;
  border-radius: 50%;
}
</style>
